import React from 'react';
import {
  GeckoBtns,
  GeckoCardBody,
  GeckoCardHeader,
  GeckoCardWrapper,
} from 'ui/components';
import { useRedux } from 'services/gecko-store/redux';
import { openExportConfirmationModal } from '../../../components/ExportButtonHandlers';
import { useWatchedExportExecution } from 'services/export-service';
import { useGetRequest } from '../../../services/gecko-request';

const useExportButton = (userEmail, dataType) => {
  const [startedExecution, setStartedExecution] = React.useState(false);
  const [latestExecution] = useGetRequest(`/exports/system/${dataType}`);
  const watchedExecution = useWatchedExportExecution(
    startedExecution || latestExecution || {}
  );
  const isExporting = ['Started Export', 'In progress'].includes(
    watchedExecution.status
  );

  return [isExporting, startedExecution, setStartedExecution];
};

export function OneOffExportsCard() {
  const userEmail = useRedux((state) => state.appState.loggedInUser.email);
  const [
    conversationExporting,
    conversationStartedExecution,
    setConversationStartedExecution,
  ] = useExportButton(userEmail, 'conversation');
  const [
    contactsExporting,
    contactsStartedExecution,
    setContactsStartedExecution,
  ] = useExportButton(userEmail, 'contact');

  const btnIcon = 'far fa-download';

  const btns = [
    {
      name: 'Export Conversations',
      icon: btnIcon,
      disabled: conversationExporting,
      handler: openExportConfirmationModal(
        userEmail,
        setConversationStartedExecution,
        'conversation',
        conversationStartedExecution
      ),
    },
    {
      name: 'Export Contacts',
      icon: btnIcon,
      disabled: contactsExporting,
      handler: openExportConfirmationModal(
        userEmail,
        setContactsStartedExecution,
        'contact',
        contactsStartedExecution
      ),
    },
  ];

  return (
    <GeckoCardWrapper>
      <GeckoCardHeader
        name="One Off Exports"
        icon="fas fa-question-circle"
        iconText="Export all your data through a one off export"
      />
      <GeckoCardBody padded>
        <div className="mb-3">Choose the data you would like to export.</div>
        <GeckoBtns items={btns} />
      </GeckoCardBody>
    </GeckoCardWrapper>
  );
}
